import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  CreateRecipientBankAccountDto,
  CreateRecipientBankAccountEntity,
  RecipientBankAccountService,
} from 'services/openapi';

import { RecipientBankAccountQueryKeys } from '../constants';

export const useCreateAccountBankMutation = () => {
  const queryClient = useQueryClient();

  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<
      CreateRecipientBankAccountEntity,
      Error,
      CreateRecipientBankAccountDto
    >({
      mutationFn: (variables: CreateRecipientBankAccountDto) =>
        RecipientBankAccountService.recipientBankAccountControllerCreate(
          variables,
        ),
      onSuccess: () =>
        queryClient.invalidateQueries([
          RecipientBankAccountQueryKeys.GET_OWN_LIST,
        ]),
    });

  return {
    isLoading,
    isSuccess,
    error,
    data,
    isError,
    mutate,
    mutateAsync,
  };
};
